<template>
  <div
    v-if="inputs !== undefined"
    class="sub-section">
    <b-field class="">
      <b-switch
        v-model="isEnabled"
        type="is-info">
        Add a pivot to this tracker table
      </b-switch>
    </b-field>

    <template v-if="isEnabled && inputs">
      <b-field
        class="input-field"
        label="Pivot Dimension">
        <CompanyDimensionRefSelect v-model="inputs.dimension" />
      </b-field>

      <OrderConfigEditor
        v-model="inputs.order"
        :errors="childErrors('order', errors)" />

      <b-field
        class="input-field mt-5"
        label="Row Limit (optional)">
        <b-numberinput
          v-model="inputs.row_limit"
          :min="0"
          controls-alignment="right"
          @wheel.native.prevent />
      </b-field>

      <b-field
        class="input-field"
        label="Filter Pivot Values">
        <FilterConfigListEditor
          v-model="inputs.filters"
          :errors="childErrors('filters', errors)" />
      </b-field>
    </template>
  </div>
</template>

<script>
  import CompanyDimensionRefSelect from '@/components/reports/config/dimensions/CompanyDimensionRefSelect'
  import FilterConfigListEditor from '@/components/reports/config/modules/common/FilterConfigListEditor'
  import OrderConfigEditor from '@/components/reports/config/modules/common/OrderConfigEditor'
  import { childErrors as _childErrors } from '@/components/reports/config/common/validation'

  export default {
    name: 'TrackerPivotRows',
    components: {
      CompanyDimensionRefSelect,
      FilterConfigListEditor,
      OrderConfigEditor,
    },
    props: {
      value: {
        type: Object,
        default: () => {},
      },
      errors: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      inputs: {
        get () {
          return this.value
        },
        set (value) {
          this.$emit('input', value)
        },
      },
      isEnabled: {
        get () {
          return this.inputs !== null
        },
        set (enabled) {
          if (enabled) {
            this.inputs = {
              filters: [],
            }
          } else {
            this.inputs = null
          }
        },
      },
    },
    methods: {
      childErrors: _childErrors,
    },
  }
</script>

<style lang="scss" scoped></style>
